var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-tabs', {
    staticClass: "tab tab--inline mb-50 mb-md-70 mb-lg-80",
    attrs: {
      "height": "18",
      "centered": ""
    }
  }, [_c('v-tab', {
    staticClass: "tab__li",
    on: {
      "click": function click($event) {
        _vm.filter.category = '';
      }
    }
  }, [_vm._v("전체")]), _c('v-tab', {
    staticClass: "tab__li",
    on: {
      "click": function click($event) {
        _vm.filter.category = 'WORKSHOP';
      }
    }
  }, [_vm._v("해외 워크숍")]), _c('v-tab', {
    staticClass: "tab__li",
    on: {
      "click": function click($event) {
        _vm.filter.category = 'SEMINAR';
      }
    }
  }, [_vm._v("국내 세미나")]), _c('v-tab', {
    staticClass: "tab__li",
    on: {
      "click": function click($event) {
        _vm.filter.category = 'AMBASSADOR';
      }
    }
  }, [_vm._v("브랜드 홍보대사")]), _c('v-tab', {
    staticClass: "tab__li",
    on: {
      "click": function click($event) {
        _vm.filter.category = 'FUND_RASER';
      }
    }
  }, [_vm._v("펀드레이저")]), _c('v-tab', {
    staticClass: "tab__li",
    on: {
      "click": function click($event) {
        _vm.filter.category = 'DAIARY';
      }
    }
  }, [_vm._v("일상")])], 1), _c('v-row', {
    staticClass: "ma-n2"
  }, _vm._l(_vm.boards, function (photo, idx) {
    return _c('v-col', {
      key: idx,
      staticClass: "pa-2",
      attrs: {
        "cols": "6",
        "md": "3"
      }
    }, [_c('div', {
      staticClass: "thumb-wrap",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function click($event) {
          return _vm.popup(photo);
        }
      }
    }, [_c('div', {
      staticClass: "thumb",
      style: "background-image: url(".concat(photo.thumb, ")")
    })])]);
  }), 1), _c('div', {
    staticClass: "mt-50 mt-lg-80"
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.pageCount,
      "total-visible": 11
    },
    on: {
      "input": function input($event) {
        return _vm.search();
      }
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1), _c('popup', {
    ref: "modal",
    attrs: {
      "img": _vm.img
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }